<script>
  import { wrap } from 'svelte-spa-router/wrap';
  import Router from 'svelte-spa-router';
  import { location } from 'svelte-spa-router'; // 현재 경로 감지
  import routes from './routes';
  import Layout from './layouts/Layout.svelte';

  $: currentRoute = $location; // reactive
  const noLayoutRoutes = ['/'];
</script>

{#if noLayoutRoutes.includes(currentRoute)}
  <!-- 로그인 페이지 등: Layout 없이 -->
  <Router {routes} useHash={true} />
{:else}
  <!-- 나머지 페이지는 Layout으로 감싸기 -->
  <Layout>
    <Router {routes} useHash={true} />
  </Layout>
{/if}